<template>
<div id="edrive" >
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <v-card class="pa-1" >

                    <v-card-text>
                        <div style=" width:100%; z-index:1000;  margin-left: 10px;  "  >
                            <img  src="/static/logo-negro-min.png" alt="proControl" style="width:200px;" />
                        </div><p/>
                        <div style="position:absolute; width:100%; z-index:1000; left:50%; margin-left: -250px; top:30px; ">
                              <h3 >  <b>C O N S U L T A R  &nbsp; &nbsp;&nbsp;&nbsp; E X P E D I E N T E </b></h3>
                        </div>
                        <div style="position:absolute; width:100%; z-index:1000; left:100%; margin-left: -250px; top:10px; ">
                             <v-chip large class="ma-2" label color="secondary"> <h5>&nbsp; <v-icon left> mdi-label</v-icon> <b> RFC: {{rfc}}</b></h5></v-chip>
                        </div>

                        <v-layout align-center >
                            <v-flex xs4 style="margin-top:-30px; padding-right:5px; " >
                                <v-card class="mx-auto primary" min-height="550px" >
                                    <v-sheet class="pa-5 primary" >
                                        <v-row>

                                            <v-col cols="12" sm="10" lg="10" class="pa-0 ps-3" >
                                                <v-text-field style="width:380px;" v-model="search" label="No. Pedimento, eDoc, Cove." v-on:keyup.enter="buscar" dark text solo-inverted hide-details clearable clear-icon="mdi-close-circle-outline" ></v-text-field>

                                            </v-col>
                                            <v-col cols="12" sm="2" lg="2" class="pa-0 ps-2 pt-1" >
                                                <v-btn icon dark title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                                                    <v-icon colorHover="secondary" color="white" size="48" >mdi-clipboard-list-outline</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>

                                        <v-dialog v-model="dialog1" max-width="500px" style="z-index:1001;">
                                            <v-card>

                                                <v-card-text>
                                                    <h5>Ingrese lista de archivos</h5>
                                                    <small><b>Consulta máxima de 15 pedimentos</b></small>
                                                    <v-textarea outlined rows="15" v-model="listado" ></v-textarea>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn small @click="listado=''; dialog1 = false" >Cancelar</v-btn>
                                                    <v-btn small color="primary" @click="buscar_all(); dialog1 = false" >Buscar</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-sheet>
                                    <v-card-text>
                                        <div class="tree" >
                                            <div class="contenido" >
                                                <v-treeview v-model="tree" :items="items" active-class="secondary lighten-4 indigo--text" :active.sync="active" activatable @update:active="preview" returnObject dense :open-all="items.length==1" :key="key" >
                                                    <template v-slot:prepend="{ item, open }" >
                                                        <v-icon v-if="item.file == 'folder' || item.file == 'grupo' " >{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
                                                        <v-icon v-else>{{ files[item.file.toUpperCase()]?files[item.file.toUpperCase()]:'mdi-file' }}</v-icon>
                                                    </template>
                                                </v-treeview>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs8 style="margin-top:-30px;" >
                                <v-card class="mx-auto primary" min-height="550px" :key="search" >
                                    <v-card-title class="primary white--text"  v-if="active.length > 0">
                                        <v-icon small class="white--text" >search</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Vista Previa{{file}}</strong>
                                        </span>
                                    </v-card-title>
                                    <v-card-text  v-if="active.length > 0">
                                        <br />

                                        <table class="table table-condensed white--text" >
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <span id="lab_title_file" >Año:</span>
                                                        <strong>
                                                            <span id="lab_file" >{{active[0].anio}}</span>

                                                        </strong>
                                                    </td>
                                                    <td>
                                                        <span id="lab_title_file" >Archivo:</span>
                                                        <strong>
                                                            <span id="lab_file" > {{active[0].name}}</span>
                                                        </strong>
                                                    </td>

                                                    <td>Tamaño:</td>

                                                    <td>
                                                        <strong>
                                                            <span id="lab_size" >{{active[0].size}} MB</span>
                                                        </strong>
                                                    </td>

                                                    <td style="padding-top:5px !important;" >
                                                       <v-btn v-if="active[0].file != 'folder' && active[0].file != 'zip'" rounded color="green" x-small @click="download" title="Descargar" v-tippy>
                                                            <v-icon small>mdi-download</v-icon>Descargar
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-if="active[0].file.toUpperCase() =='XML' || active[0].file.toUpperCase() =='TXT' ||  parseInt(active[0].file)  > 0  || active[0].file.toUpperCase()  =='ERR'" class="global" >
                                            <div class="contenidotxt" >
                                                <pre>{{xmlContent}} </pre>
                                            </div>
                                        </div>

                                        <div id="app" v-if="( active[0].file.toUpperCase() =='PDF') && url!='' " >
                                            <PDFViewer v-bind="{url}" @document-errored="onDocumentErrored" ></PDFViewer>
                                        </div>
                                        <div v-if="active[0].file.toUpperCase() =='JPG' || active[0].file.toUpperCase() =='JPEG'" class="global" >
                                            <div class="contenido" >
                                                <v-img :src="`data:image/jpg;base64,${url}`" max-width="900px" ></v-img>
                                            </div>

                                        </div>
                                        <div v-if="active[0].file.toUpperCase() =='PNG'" class="global" >
                                            <div class="contenido" >
                                                <v-img :src="`data:image/png;base64,${url}`" max-width="900px" ></v-img>
                                            </div>

                                        </div>
                                        <v-alert border="top" colored-border type="info" elevation="2" v-if="active[0].file.toUpperCase() !='PDF'
                                        && active[0].file.toUpperCase()  !='XML' && active[0].file.toUpperCase()  !='PNG' && active[0].file.toUpperCase()  !='JPG' && active[0].file.toUpperCase()  !='JPEG' && active[0].file.toUpperCase()  !='TXT'
                                        && active[0].file !=''  && !parseInt(active[0].file)>0  && active[0].file.toUpperCase()  !='ERR' " >Vista previa no disponible.
                                        </v-alert>

                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>

            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import {
    request
} from "http";
import {
    mapState
} from "vuex";
import axios from "axios";
import PDFViewer from "@/components/pdf/PDFViewer.vue";
import beautify from "xml-beautifier";


export default {
    components: {
        PDFViewer
    },
    created() {
       // "U2FsdGVkX18kBJtypiW6yTIrsLjCD6D90uS/3Hzn6y0="





    },
    computed: {


    },
    mounted() {

        let ekey =  this.$route.params.ekey;
        let pedimento =  this.$route.params.pedimento;
            this.rfc = this.$crypto.decrypted(ekey);
            console.log( this.rfc);
            if(this.rfc.length != 12 || this.rfc == ""){
                this.$router.push("/login").catch(()=>{});
            }
            if(pedimento != 'P' && pedimento.length == 16){
                this.search = pedimento;
                this.buscar();

               // this.active = this.items[2];
            }

    },
    methods: {
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        preview() {
            // Para eliminar todo el expediente
            this.borrableExpediente = false;
            if (this.active.length > 0 && Number.isInteger(this.active[0].id) && this.active[0].file == "folder") {
                this.borrableExpediente = true;
            }

            this.borrable = !this.active.length || this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";

            if (!this.active.length || this.active[0].file == "zip" || this.active[0].file == "folder") {
                return undefined;
            }

            if (this.active[0].file.toUpperCase() == "PDF" || this.active[0].file.toUpperCase() == "XML" || this.active[0].file.toUpperCase() == "PNG"  || this.active[0].file.toUpperCase() == "JPG"|| this.active[0].file.toUpperCase() == "JPEG"|| this.active[0].file.toUpperCase() == 'TXT' || parseInt(this.active[0].file) > 0 || this.active[0].file.toUpperCase() == 'ERR') {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                this.xmlError = false;
                var datos = {
                    id: this.active[0].dir,
                    bucket: "production.econnect.ds"
                }
                this.xmlContent = "";
                var result = "";
                axios.post(this.$hostname + 's3/download/', datos)
                    .then((response) => {
                        if (typeof response.data !== 'undefined') {
                            let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                                    type: response.headers["content-type"]
                                }),
                                url = window.URL.createObjectURL(blob);
                            if (this.active[0].file.toUpperCase() == "PDF") {
                                this.url = url;
                            }
                            if (this.active[0].file.toUpperCase() == "XML" ) {
                                this.xmlContent = beautify(atob(response.data));
                            }
                            if (this.active[0].file.toUpperCase() == 'TXT' || parseInt(this.active[0].file) > 0 || this.active[0].file.toUpperCase() == 'ERR') {
                                this.xmlContent =atob(response.data)
                            }
                            if (this.active[0].file.toUpperCase() == "PNG" || this.active[0].file.toUpperCase() == "JPG" || this.active[0].file.toUpperCase() == "JPEG") {
                                this.url = response.data
                            }
                        } else {
                            this.url = "";

                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                                footer: '',
                            });
                        }
                        this.borrable = this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";
                        this.$root.$dialogLoader.hide();
                    })
                    .catch((error) => {
                        this.url = "";
                        this.xmlContent = ""
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined && error.response.data.mensaje == "Archivo no encontrado") {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            this.$swal({
                                type: "info",
                                title: "Importante",
                                text: "El tamaño del archivo no permite mostrarlo en el visor de documentos ¿Desea descargar el archivo?" ,
                                footer: "",
                                showCancelButton: true,
                                cancelButtonColor: "#d33",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "Aceptar",
                                cancelButtonText: "Cancelar"
                            }).then(result => {
                                if (result.value) {
                                    this.downloadFileUrl(datos.id);
                                } else {
                                    this.$root.$dialogLoader.hide();
                                }
                            });
                        }
                        this.borrable = this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";

                    });
            }

        },
        download() {
            if (this.active[0].file == "zip" || this.active[0].file == "folder") {
                this.generateZip(this.active[0].dir);
            } else {
                if (this.active[0].file.toUpperCase() == "XML") {
                    this.downloadFile(this.active[0].dir);
                } else {
                    try {
                        if (parseFloat(this.active[0].size) > 3.5) //Si pesa mas de 3.5MB que lo baje por url
                            this.downloadFileUrl(this.active[0].dir);
                        else
                            this.downloadFile(this.active[0].dir);
                    } catch (error) {
                        this.downloadFileUrl(this.active[0].dir);
                    }

                }
            }

        },
        urlUpdated(url) {
            this.documentError = undefined;
            this.url = url;
        },
        onDocumentErrored(e) {
            this.documentError = e.text;
        },

        buscar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.active = [];
            if (this.search === null) {
                this.$root.$dialogLoader.hide();
                return false;
            }
            var data = {
                rfc: this.rfc,
                filename: this.search,
            };
            axios
                .post(this.$apiReportes + "reportes/get_consulta_file/", data)
                .then(res => {
                    var self = this;
                    self.items = [];
                    if (res.data.length > 0) {
                        res.data.forEach(function (item) {
                            var i = 1;
                            var children = [];
                            var coves = [];
                            var edocuments = [];

                            var remesas = [];
                            var adjuntos = [];
                            var mve = [];
                            var size_mve = 0;
                            var af_file = [];
                            var size_partidas = 0;
                            var cuenta_partidas = 0;
                            var size_coves = 0;
                            var size_edocuments = 0;
                             var coves2 = [];
                            var edocuments2 = [];
                             var size_coves2 = 0;
                            var size_edocuments2 = 0;
                            var size_remesas = 0;
                            var size_adjuntos = 0;
                            var size_af = 0;
                            self.key = item.id;
                            item.validacion.forEach(function (v) {
                                if (v.size > 0) {
                                    v.size = (((v.size / 1024)) / 1024).toFixed(3);
                                }
                                if (v.estatus == 2) {
                                    if (v.tipo < 6 || v.tipo == 19 || v.tipo == 20) {
                                        children.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            anio: item.anio,
                                            dir: item.path + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                    }

                                    if (v.tipo == 'remesas') {
                                        children.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            anio: item.anio,
                                            dir: item.path + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                    }

                                    if (v.tipo == 6) {
                                        size_partidas = size_partidas + parseFloat(v.size);
                                        cuenta_partidas += 1;
                                    }
                                    if ((v.tipo == 7 || v.tipo == 8 || v.tipo == 10)) {
                                        coves.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            anio: item.anio,
                                            dir: item.path + "coves/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_coves = size_coves + parseFloat(v.size);
                                    }
                                    if ((v.tipo == 11 || v.tipo == 12 || v.tipo == 14)) {
                                        edocuments.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            anio: item.anio,
                                            dir: item.path + "eDocuments/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_edocuments = size_edocuments + parseFloat(v.size);
                                    }
                                    if ((v.tipo == 15 || v.tipo == 16 || v.tipo == 18)) {
                                        remesas.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            anio: item.anio,
                                            dir: item.path + "coves/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_remesas = size_remesas + parseFloat(v.size);
                                    }

                                    if ((v.tipo == 31 || v.tipo == 32 || v.tipo == 33)) { //Manifestacion
                                        mve.push({
                                            id: item.anio + v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            anio: item.anio,
                                            dir: item.path + "manifestacion/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_mve = size_mve + parseFloat(v.size);
                                      }
                                   if ((v.tipo == 31 )) { //Manifestacion
                                    item.validacion_manifestacion.sort(function(a, b){
                                                return a.filename > b.filename;
                                            });
                                         item.validacion_manifestacion.forEach(function (m) {
                                                 if ((m.tipo == 7 || m.tipo == 8 || m.tipo == 10)) {
                                                    coves2.push({
                                                        id: "m" + m.filename + "." + m.ext,
                                                        name: m.filename + "." + m.ext,
                                                        anio: item.anio,
                                                        dir: item.path + "manifestacion/coves/" + m.filename + "." + m.ext,
                                                        file: m.ext,
                                                        size: m.size,
                                                        expediente: false
                                                    });
                                                    size_coves2 = size_coves2 + parseFloat(m.size);
                                                }
                                                if ((m.tipo == 11 || m.tipo == 12 || m.tipo == 14)) {
                                                    edocuments2.push({
                                                        id: "m" + m.filename + "." + m.ext,
                                                        name: m.filename + "." + m.ext,
                                                        anio: item.anio,
                                                        dir: item.path + "manifestacion/eDocuments/" + m.filename + "." + m.ext,
                                                        file: m.ext,
                                                        size: m.size,
                                                        expediente: false
                                                    });
                                                    size_edocuments2 = size_edocuments2 + parseFloat(m.size);
                                                }
                                          });
                                    }
                                    i = i + 1;
                                }

                            });

                            var carpetas_adjuntos = [];
                            let tiene_archivos_pedimento = false;
                            let tiene_AF = false;
                            item.adjuntos = item.adjuntos.sort(function (a, b) {
                                return a.filename > b.filename;
                            });
                            item.adjuntos.forEach(function (j) {
                                var sub = j.filename.split("_");
                                if (sub.length > 0) {
                                    if (carpetas_adjuntos.includes(sub[0]) == false) {
                                        if (sub[0] != 'P030' && sub[0] != 'P031' && sub[0] != 'P032' && sub[0] != 'P033' && !sub[0].toUpperCase().startsWith('AF') ) {
                                            carpetas_adjuntos.push(sub[0]);
                                        } else {
                                            if ( sub[0] == 'P030' || sub[0] == 'P031' || sub[0] == 'P032' || sub[0] == 'P033' )
                                                tiene_archivos_pedimento = true;

                                        }
                                    }
                                }
                            });
                            if (tiene_archivos_pedimento) {
                                carpetas_adjuntos.push("ArchivosPedimento");
                            }
                            var l = 0;
                            var size = 0;
                            var child_af= [];
                            var child_af_size = 0;
                            carpetas_adjuntos.forEach(function (y) {
                                var child_adjuntos = [];
                                var child_adjuntos_size = 0;

                                var w = 1;
                                item.adjuntos.forEach(function (z) {
                                    size = 0;
                                    if (z.size > 0) {
                                        size = parseFloat((((z.size / 1024)) / 1024)).toFixed(3);
                                    }
                                    var sub = z.filename.split("_");
                                    if (sub.length > 0) {
                                        if (sub[0] == y || (y == "ArchivosPedimento" && (sub[0] == 'P030' || sub[0] == 'P031' || sub[0] == 'P032' || sub[0] == 'P033'))) {
                                            sub = sub[0] + "/";
                                            child_adjuntos.push({
                                                id: sub + z.filename + "." + z.ext,
                                                name: z.filename + "." + z.ext,
                                                anio: item.anio,
                                                dir: item.path + "adjuntos/" + sub + z.filename + "." + z.ext,
                                                file: z.ext,
                                                size: size,
                                                expediente: false
                                            });
                                            child_adjuntos_size = child_adjuntos_size + parseFloat(z.size);
                                        }

                                    }
                                    w = w + 1;

                                });
                                size = 0;
                                if (child_adjuntos_size > 0) {
                                    size = parseFloat((((child_adjuntos_size / 1024)) / 1024)).toFixed(3);
                                }
                                if (y == "ArchivosPedimento") {
                                    adjuntos.push({
                                        id: item.id * l + 100000,
                                        name: y,
                                        anio: item.anio,
                                        dir: "",
                                        file: "grupo",
                                        size: size,
                                        children: child_adjuntos,
                                            expediente: false
                                    });
                                } else {

                                    adjuntos.push({
                                        id: item.id * l + 100000,
                                        name: y,
                                        anio: item.anio,
                                        dir: item.path + "adjuntos/" + y,
                                        file: "folder",
                                        size: size,
                                        children: child_adjuntos,
                                            expediente: false
                                    });
                                }

                                size_adjuntos = size_adjuntos + parseFloat(child_adjuntos_size);

                                l = l + 1;
                            });


                            // llena los AF
                            item.adjuntos.forEach(function (z) {
                                    size = 0;
                                    if (z.size > 0) {
                                        size = parseFloat((((z.size / 1024)) / 1024)).toFixed(3);
                                    }
                                    var sub = z.filename.split("_");
                                    if (sub.length > 0) {

                                        if (sub[0].toUpperCase().startsWith('AF')) {
                                            sub = sub[0] + "/";
                                            child_af.push({
                                                id: sub + z.filename + "." + z.ext,
                                                name: z.filename + "." + z.ext,
                                                 anio: item.anio,
                                                dir: item.path + "adjuntos/" + sub + z.filename + "." + z.ext,
                                                file: z.ext,
                                                size: size,
                                            expediente: false
                                            });
                                            child_af_size = child_af_size + parseFloat(z.size);
                                        }
                                    }
                            });


                            if (cuenta_partidas > 0) {
                                children.push({
                                    id: "Partidas",
                                    name: "Partidas (" + cuenta_partidas + ").zip",
                                    anio: item.anio,
                                    dir: item.path + "partidas",
                                    file: "zip",
                                    size: size_partidas.toFixed(2),
                                            expediente: false
                                });
                            }
                            if (coves.length > 0) {
                                children.push({
                                    id: "coves",
                                    name: "Coves",
                                    anio: item.anio,
                                    dir: item.path + "coves",
                                    file: "folder",
                                    size: size_coves.toFixed(2),
                                    children: coves,
                                            expediente: false
                                });

                            }
                            if (edocuments.length > 0) {
                                children.push({
                                    id: "Edocuments",
                                    name: "Edocuments",
                                    anio: item.anio,
                                    dir: item.path + "eDocuments",
                                    file: "folder",
                                    size: size_edocuments.toFixed(2),
                                    children: edocuments,
                                            expediente: false
                                });

                            }
                            if (remesas.length > 0) {
                                children.push({
                                    id: "coves",
                                    name: "Coves",
                                    anio: item.anio,
                                    dir: item.path + "coves",
                                    file: "folder",
                                    size: size_remesas.toFixed(2),
                                    children: remesas,
                                            expediente: false
                                });

                            }

                            if (mve.length > 0) {
                                  if (coves2.length > 0) {
                                            mve.push({
                                                id: "covesmv",
                                                name: "Coves MVs",
                                                anio: item.anio,
                                                dir: item.path + "manifestacion/coves",
                                                file: "folder",
                                                size: size_coves2.toFixed(2),
                                                children: coves2,
                                                        expediente: false
                                            });

                                        }
                                    if (edocuments2.length > 0) {
                                        mve.push({
                                            id: "Edocumentsmv",
                                            name: "Edocuments MVs",
                                            anio: item.anio,
                                            dir: item.path + "manifestacion/eDocuments",
                                            file: "folder",
                                            size: size_edocuments2.toFixed(2),
                                            children: edocuments2,
                                                    expediente: false
                                        });
                                      }


                                  children.push({
                                    id: item.anio + "MVE",
                                    name: "Manifestación de Valor Electrónica",
                                    anio: item.anio,
                                    dir: item.path + "manifestacion",
                                    file: "folder",
                                    size: size_mve.toFixed(2),
                                    children: mve,
                                    expediente: false
                                });


                            }


                            if (child_af.length > 0) {
                                children.push({
                                    id: "AFFILE",
                                    name: "AF_FILE",
                                    anio: item.anio,
                                    dir: item.path + "af_file",
                                    file: "folder",
                                    size: ((child_af_size / 1024) / 1024).toFixed(2),
                                    children: child_af,
                                     expediente: false
                                });

                            }
                            if (adjuntos.length > 0) {
                                children.push({
                                    id: "Adjuntos",
                                    name: "Adjuntos",
                                    anio: item.anio,
                                    dir: item.path + "adjuntos",
                                    file: "folder",
                                    size: ((size_adjuntos / 1024) / 1024).toFixed(2),
                                    children: adjuntos,
                                    expediente: false
                                });

                            }
                            var pathPedimento = self.rfc+"/pedimentos/"+item.anio.toString();
                            if(item.path!=null && item.path!=undefined && item.path!=""){
                                pathPedimento = item.path
                            }
                            self.items.push({
                                id: item.id,
                                name: item.no_pedimento,
                                anio: item.anio,
                                dir: pathPedimento,
                                file: "folder",
                                size: ((item.size / 1024) / 1024).toFixed(2),
                                children: children,
                                datastage: item.datastage,
                                expediente: true
                            });

                        });

                        self.active.push(this.items[0].children[1]);
                        self.preview();
                    } else {
                        this.$swal({
                            type: "error",
                            title: "No se encontraron resultados",
                            text: this.search,
                            footer: ""
                        });
                    }
                    this.$root.$dialogLoader.hide();
                })
                .catch(err => {
                    this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al consultar el archivo",
                        footer: ""
                    });
                    console.log(err);
                });

        },
        buscar_all: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.active = [];

            if (this.listado.split("\n").length > 15) {
                this.$root.$dialogLoader.hide();

                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: 'El máximo de pedimentos en la lista es 15',
                    footer: '',
                });

                return false;
            }

            var data = {
                rfc: this.rfc,
                filenames: this.listado.split("\n"),
            };

            axios
                .post(this.$apiReportes + "reportes/get_consulta_files/", data)
                .then(res => {

                    var self = this;
                    self.items = [];
                    if (res.data.length > 0) {
                        res.data.forEach(function (item) {
                            var i = 1;
                            var children = [];
                            var coves = [];
                            var edocuments = [];
                            var remesas = [];
                            var adjuntos = [];
                            var mve = [];
                            var size_mve = 0;
                            var size_partidas = 0;
                            var cuenta_partidas = 0;
                            var size_coves = 0;
                            var size_edocuments = 0;
                            var size_remesas = 0;
                            var size_adjuntos = 0;
                              var coves2 = [];
                            var edocuments2 = [];
                             var size_coves2 = 0;
                            var size_edocuments2 = 0;
                            var child_af= [];
                            var child_af_size = 0;

                            self.key = item.id;
                            item.validacion.forEach(function (v) {
                                if (v.size > 0) {
                                    v.size = (((v.size / 1024)) / 1024).toFixed(3);
                                }
                                if (v.estatus == 2) {
                                   if (v.tipo < 6 || v.tipo == 19 || v.tipo == 20) {
                                        children.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            anio: item.anio,
                                            dir: item.path + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                    }

                                    if (v.tipo == 'remesas') {
                                        children.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            anio: item.anio,
                                            dir: item.path + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                    }

                                    if (v.tipo == 6) {
                                        size_partidas = size_partidas + parseFloat(v.size);
                                        cuenta_partidas += 1;
                                    }
                                    if ((v.tipo == 7 || v.tipo == 8 || v.tipo == 10)) {
                                        coves.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            anio: item.anio,
                                            dir: item.path + "coves/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_coves = size_coves + parseFloat(v.size);
                                    }
                                    if ((v.tipo == 11 || v.tipo == 12 || v.tipo == 14)) {
                                        edocuments.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            anio: item.anio,
                                            dir: item.path + "eDocuments/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_edocuments = size_edocuments + parseFloat(v.size);
                                    }
                                    if ((v.tipo == 15 || v.tipo == 16 || v.tipo == 18)) {
                                        remesas.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            anio: item.anio,
                                            dir: item.path + "coves/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_remesas = size_remesas + parseFloat(v.size);
                                    }

                                    if ((v.tipo == 31 || v.tipo == 32 || v.tipo == 33)) { //Manifestacion
                                        mve.push({
                                            id: item.anio + v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            anio: item.anio,
                                            dir: item.path + "manifestacion/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_mve = size_mve + parseFloat(v.size);
                                    }
                                     if ((v.tipo == 31 )) { //Manifestacion
                                    item.validacion_manifestacion.sort(function(a, b){
                                                return a.filename > b.filename;
                                            });
                                         item.validacion_manifestacion.forEach(function (m) {
                                                 if ((m.tipo == 7 || m.tipo == 8 || m.tipo == 10)) {
                                                    coves2.push({
                                                        id: "m" + m.filename + "." + m.ext,
                                                        name: m.filename + "." + m.ext,
                                                        anio: item.anio,
                                                        dir: item.path + "manifestacion/coves/" + m.filename + "." + m.ext,
                                                        file: m.ext,
                                                        size: m.size,
                                                        expediente: false
                                                    });
                                                    size_coves2 = size_coves2 + parseFloat(m.size);
                                                }
                                                if ((m.tipo == 11 || m.tipo == 12 || m.tipo == 14)) {
                                                    edocuments2.push({
                                                        id: "m" + m.filename + "." + m.ext,
                                                        name: m.filename + "." + m.ext,
                                                        anio: item.anio,
                                                        dir: item.path + "manifestacion/eDocuments/" + m.filename + "." + m.ext,
                                                        file: m.ext,
                                                        size: m.size,
                                                        expediente: false
                                                    });
                                                    size_edocuments2 = size_edocuments2 + parseFloat(m.size);
                                                }
                                          });
                                    }

                                    i = i + 1;
                                }

                            });
                            let tiene_archivos_pedimento = false;
                            let tiene_AF = false;
                            var carpetas_adjuntos = [];
                            item.adjuntos = item.adjuntos.sort(function (a, b) {
                                return a.filename > b.filename;
                            });
                            item.adjuntos.forEach(function (j) {
                                var sub = j.filename.split("_");
                                if (sub.length > 0) {
                                    if (carpetas_adjuntos.includes(sub[0]) == false) {
                                        if (sub[0] != 'P030' && sub[0] != 'P031' && sub[0] != 'P032' && sub[0] != 'P033' && !sub[0].toUpperCase().startsWith('AF') ) {
                                            carpetas_adjuntos.push(sub[0]);
                                        } else {
                                            if ( sub[0] == 'P030' || sub[0] == 'P031' || sub[0] == 'P032' || sub[0] == 'P033' )
                                                tiene_archivos_pedimento = true;

                                        }
                                    }
                                }
                            });
                            if (tiene_archivos_pedimento) {
                                carpetas_adjuntos.push("ArchivosPedimento");
                            }
                            var l = 0;
                            var size = 0;
                            var child_af= [];
                            var child_af_size = 0;

                            carpetas_adjuntos.forEach(function (y) {
                                var child_adjuntos = [];
                                var child_adjuntos_size = 0;
                                var w = 1;
                                item.adjuntos.forEach(function (z) {

                                    size = 0;
                                    if (z.size > 0) {
                                        size = parseFloat((((z.size / 1024)) / 1024)).toFixed(3);
                                    }
                                    var sub = z.filename.split("_");
                                    if (sub.length > 0) {
                                        if (sub[0] == y || (y == "ArchivosPedimento" && (sub[0] == 'P030' || sub[0] == 'P031' || sub[0] == 'P032' || sub[0] == 'P033'))) {
                                            sub = sub[0] + "/";
                                            child_adjuntos.push({
                                                id: sub + z.filename + "." + z.ext,
                                                name: z.filename + "." + z.ext,
                                                anio: item.anio,
                                                dir: item.path + "adjuntos/" + sub + z.filename + "." + z.ext,
                                                file: z.ext,
                                                size: size,
                                            expediente: false
                                            });
                                            child_adjuntos_size = child_adjuntos_size + parseFloat(z.size);
                                        }
                                    }
                                    w = w + 1;

                                });
                                size = 0;
                                if (child_adjuntos_size > 0) {
                                    size = parseFloat((((child_adjuntos_size / 1024)) / 1024)).toFixed(3);
                                }
                                if (y == "ArchivosPedimento") {
                                    adjuntos.push({
                                        id: item.id * l + 100000,
                                        name: y,
                                        anio: item.anio,
                                        dir: "",
                                        file: "grupo",
                                        size: size,
                                        children: child_adjuntos,
                                            expediente: false
                                    });
                                } else {

                                    adjuntos.push({
                                        id: item.id * l + 100000,
                                        name: y,
                                        anio: item.anio,
                                        dir: item.path + "adjuntos/" + y,
                                        file: "folder",
                                        size: size,
                                        children: child_adjuntos,
                                            expediente: false
                                    });
                                }

                                size_adjuntos = size_adjuntos + parseFloat(child_adjuntos_size);

                                l = l + 1;
                            });

                             // llena los AF
                            item.adjuntos.forEach(function (z) {
                                    size = 0;
                                    if (z.size > 0) {
                                        size = parseFloat((((z.size / 1024)) / 1024)).toFixed(3);
                                    }
                                    var sub = z.filename.split("_");
                                    if (sub.length > 0) {

                                        if (sub[0].toUpperCase().startsWith('AF')) {
                                            sub = sub[0] + "/";
                                            child_af.push({
                                                id: sub + z.filename + "." + z.ext,
                                                name: z.filename + "." + z.ext,
                                                anio: item.anio,
                                                dir: item.path + "adjuntos/" + sub + z.filename + "." + z.ext,
                                                file: z.ext,
                                                size: size,
                                            expediente: false
                                            });
                                            child_af_size = child_af_size + parseFloat(z.size);
                                        }
                                    }
                            });

                            if (cuenta_partidas > 0) {
                                children.push({
                                    id: "Partidas",
                                    name: "Partidas (" + cuenta_partidas + ").zip",
                                    anio: item.anio,
                                    dir: item.path + "partidas",
                                    file: "zip",
                                    size: size_partidas.toFixed(2),
                                            expediente: false
                                });
                            }
                               if (coves.length > 0) {
                                children.push({
                                    id: "coves",
                                    name: "Coves",
                                    anio: item.anio,
                                    dir: item.path + "coves",
                                    file: "folder",
                                    size: size_coves.toFixed(2),
                                    children: coves,
                                            expediente: false
                                });

                            }
                            if (edocuments.length > 0) {
                                children.push({
                                    id: "Edocuments",
                                    name: "Edocuments",
                                    anio: item.anio,
                                    dir: item.path + "eDocuments",
                                    file: "folder",
                                    size: size_edocuments.toFixed(2),
                                    children: edocuments,
                                            expediente: false
                                });

                            }
                            if (remesas.length > 0) {
                                children.push({
                                    id: "coves",
                                    name: "Coves",
                                    anio: item.anio,
                                    dir: item.path + "coves",
                                    file: "folder",
                                    size: size_remesas.toFixed(2),
                                    children: remesas,
                                            expediente: false
                                });

                            }

                            if (mve.length > 0) {
                               if (coves2.length > 0) {
                                            mve.push({
                                                id: "covesmv",
                                                name: "Coves MVs",
                                                anio: item.anio,
                                                dir: item.path + "manifestacion/coves",
                                                file: "folder",
                                                size: size_coves2.toFixed(2),
                                                children: coves2,
                                                        expediente: false
                                            });

                                        }
                                    if (edocuments2.length > 0) {
                                        mve.push({
                                            id: "Edocumentsmv",
                                            name: "Edocuments MVs",
                                            anio: item.anio,
                                            dir: item.path + "manifestacion/eDocuments",
                                            file: "folder",
                                            size: size_edocuments2.toFixed(2),
                                            children: edocuments2,
                                                    expediente: false
                                        });
                                      }

                                children.push({
                                    id: item.anio + "MVE",
                                    name: "Manifestación de Valor Electrónica",
                                    anio: item.anio,
                                    dir: item.path + "manifestacion",
                                    file: "folder",
                                    size: size_mve.toFixed(2),
                                    children: mve,
                                    expediente: false
                                });

                            }


                            if (child_af.length > 0) {
                                children.push({
                                    id: "AFFILE",
                                    name: "AF_FILE",
                                    anio: item.anio,
                                    dir: item.path + "af_file",
                                    file: "folder",
                                    size: ((child_af_size / 1024) / 1024).toFixed(2),
                                    children: child_af,
                                     expediente: false
                                });
                            }
                            if (adjuntos.length > 0) {
                                children.push({
                                    id: "Adjuntos",
                                    name: "Adjuntos",
                                    anio: item.anio,
                                    dir: item.path + "adjuntos",
                                    file: "folder",
                                    size: ((size_adjuntos / 1024) / 1024).toFixed(2),
                                    children: adjuntos,
                                            expediente: false
                                });

                            }
                            var pathPedimento = self.rfc+"/pedimentos/"+item.anio.toString();
                            if(item.path!=null && item.path!=undefined && item.path!=""){
                                pathPedimento = item.path
                            }
                            self.items.push({
                                id: item.id,
                                name: item.no_pedimento,
                                anio: item.anio,
                                dir: pathPedimento,
                                file: "folder",
                                size: ((item.size / 1024) / 1024).toFixed(2),
                                datastage: item.datastage,
                                children: children,
                                            expediente: true
                            });

                        });
                    } else {
                        // this.$swal({
                        //     type: "error",
                        //     title: "No se encontraron resultados",
                        //     text: this.search,
                        //     footer: ""
                        // });
                    }
                    this.$root.$dialogLoader.hide();
                    //this.listado = "";
                })
                .catch(err => {
                    this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al consultar el archivo",
                        footer: ""
                    });
                    console.log(err);
                });

        },
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download/', datos)
                .then((response) => {

                    if (typeof response.data !== 'undefined') {

                        let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                                type: response.headers["content-type"]
                            }),
                            url = window.URL.createObjectURL(blob);

                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";

                        a.href = url;
                        var arreglo = key.split("/")
                        a.download = arreglo[arreglo.length - 1];
                        a.click();

                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    this.$root.$dialogLoader.hide();
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                });
        },

        generateZip: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                key: key,
                usuario: this.$local_storage.get("id_usuario"),
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_zip/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        this.$swal({
                            type: "info",
                            title: "Generado...",
                            text: "En breve recibirás una notificación para descargar el ZIP",
                            footer: '',
                        });
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        downloadFileUrl: function (dir) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: dir,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
    },
    data: () => ({
        rfc:"",
        fab: false,
        xmlError: false,
        xmlContent: "",
        url: "",
        file: "",
        search: null,
        key: 1,
        active: [],
        sel: null,
        URL: "",
        dialog1: false,
        confirm: false,
        confirmExpediente: false,
        confirmCarpeta: false,
        listado: "",
          files: {
            PDF: "mdi-file-pdf-box",
            PNG: "mdi-file-png-box",
            JPG: "mdi-file-jpg-box",
            TXT: "mdi-file-document-outline",
            XLS: "mdi-file-excel-box",
            XLSX: "mdi-file-excel-box",
            DOCX: "mdi-file-word-box",
            DOC: "mdi-file-word-box",
            XML: "mdi-xml",
            ZIP: "mdi-zip-box"
        },
        tree: [],
        items: [],
        borrable: false,
        borrableExpediente: false,
        borrableCarpeta: false,
        comentario: "",
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Consultar Expediente",
                disabled: true,
                to: ""
            }
        ],
    })
};
</script>

<style scoped>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: white;
    margin-top: 0px;
}

.error {
    border: 1px solid red;
    background: pink;
    color: red;
    padding: 0.5em 3em;
    display: inline;
}

.box-shadow {
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
}

.overflow-hidden {
    overflow: hidden;
}

@media print {
    body {
        background-color: transparent;
    }

    #app {
        margin: 0;
        padding: 0;
    }
}

.global {
    margin-left: 10px;
    margin-top: 20px;
    height: 432px;
    width: 100%;
    border: 1px solid #ddd;
    background-color: white;
    overflow: scroll;
}

.tree {
    margin-left: 0px;
    margin-top: -20px;
    height: 450px;
    width: 100%;
    border: 1px solid #ddd;
    background-color: white;
    overflow-y: scroll;
}

.contenido {
    padding: 5px;
    font-size: small;
    overflow: auto;
    background-color: white;
}

.contenidotxt {
    padding: 5px;
    font-size: small;
    overflow: auto;
    font-size: 14px !important;
    background-color: white;
}

.v-card__subtitle,
.v-card__text {
    line-height: 0.95rem !important;
}

.v-treeview--dense .v-treeview-node__root {
    min-height: 20px !important;
}

.table {
    font-size: 12px !important;
    margin-bottom: 20px;
}

.v-label {
    font-size: 8px !important;
}
</style>
